import { spaceAttachmentDescriptorSchema, spaceAttachmentDimensionSchema, spaceAttachmentFileNameSchema } from "../protocol/space-attachment.js";
import * as z$1 from "zod/v4";
//#region src/schemas/http/space-attachments.ts
const spaceAttachmentQueryDimensionSchema = z$1.string().trim().regex(/^\d+$/).transform(Number).pipe(spaceAttachmentDimensionSchema);
/**
* Optional metadata sent as query parameters on the raw-binary upload request.
* Width and height are client-declared layout hints and are not verified by
* decoding the image on the server.
*/
const spaceAttachmentUploadQuerySchema = z$1.strictObject({
	fileName: spaceAttachmentFileNameSchema.optional(),
	width: spaceAttachmentQueryDimensionSchema.optional(),
	height: spaceAttachmentQueryDimensionSchema.optional()
});
const uploadSpaceAttachmentResponseSchema = z$1.strictObject({ attachment: spaceAttachmentDescriptorSchema });
//#endregion
export { spaceAttachmentUploadQuerySchema, uploadSpaceAttachmentResponseSchema };

//# sourceMappingURL=space-attachments.js.map